// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TableError_wrapper__1Oyok","titleWrapper":"TableError_titleWrapper__2ncg5","description":"TableError_description__28IgM"};